import React from 'react';
import { renderLandingPageElement } from './LandingPage.js';
import { reMapAnalyticsOptions } from '../../util/analyticsDataAttributes.js';
import { combineClassNames } from '../../util/css/classNames.js';
import style from './Column.scss';
export const Column = (props) => (React.createElement("div", { className: combineClassNames(style.column, props.reverseMobileDirection && style.reverseDirectionInMobile) }, props.content.map((c, i) => renderLandingPageElement(reMapAnalyticsOptions(c, i, props.analyticsOptions), props.language, props.isLoggedIn))));
